/**
 * `sanitize-html` 이 escape 한 엔티티를 원래 문자로 되돌린다. `escapeHtml` 의 역방향.
 * 수식 판정·Temml 렌더처럼 평문이 필요한 곳에 넘기기 직전에만 쓴다.
 */
export const decodeHtmlEntities = (value: string): string =>
  value
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&amp;/g, '&');
